import DomHelper from '../../DomHelper'
import StoreHelper from '../../../store/helper'

import EventBus, { Events } from '../../../event-bus'

export const onDragstart = (component, el, e) => {
  DomHelper.hideElement(el)

  StoreHelper.setHoverItem(null)
  StoreHelper.setDraggingElement(StoreHelper.getActiveViewKey(), el)
  StoreHelper.setDraggingElementValue(component.item)

  setTimeout(() => {
    StoreHelper.removeDragElement(StoreHelper.getActiveViewKey(), el)
  }, 10)

  // Not found in TouchEvent
  if (e.dataTransfer) {
    e.dataTransfer.setData('text/plain', JSON.stringify(component.item))
  }
  EventBus.$emit(Events.B_MENU_ITEM_DRAG_START)
}
